import { useEffect } from "react";

const usePreventPrint = () => {
  useEffect(() => {
    const handleBeforePrint = () => {
      alert('Printing is disabled');
      window.stop();
    };

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault();
        alert('Printing is disabled');
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    window.onbeforeprint = handleBeforePrint;
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      window.onbeforeprint = null;
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
};

export default usePreventPrint;
